export const state = {
  loading: 0
};
